export const adminMenuItems = [
  {
    href: '/admin/balances',
    text: 'Balances'
  },
  {
    href: '/admin/payments',
    text: 'Payments'
  },
  {
    href: '/admin/acts',
    text: 'Acts'
  },
  {
    href: '/admin/taxbills',
    text: 'Tax bills'
  },
  {
    href: '/admin/invoices',
    text: 'Invoices'
  },
  {
    href: '/admin/documents',
    text: 'Documents'
  },
  {
    href: '/admin/users',
    text: 'Users'
  },
  {
    href: '/admin/organizations',
    text: 'Organizations'
  },
  {
    href: '/admin/templates',
    text: 'Templates'
  },
  {
    href: '/admin/tariffs',
    text: 'Tariffs'
  }
]
